import { withFormik } from "formik";
import * as Yup from "yup";
import { registrationDobSchema } from "../../../Register/Register.validator";

const namePattern = /^[A-Za-z0-9 ]+$/;

const requiresPolicyHolderFields = (relationship) => {
  const value = String(relationship ?? "").trim();
  return value === "spouse" || value === "dependent";
};

export const insuranceVerificationInitialValues = {
  payer: "",
  firstName: "",
  lastName: "",
  dob: "",
  memberId: "",
  groupNumber: "",
  relationship: "self",
  policyHolderFirstName: "",
  policyHolderLastName: "",
  policyHolderDob: "",
};

export const insuranceVerificationValidationSchema = Yup.object().shape({
  payer: Yup.string()
    .trim()
    .required("SELECT_INSURANCE_VALIDATION")
    .test("payerSelected", "SELECT_INSURANCE_VALIDATION", (value) =>
      Boolean(value && value.length > 0)
    ),
  firstName: Yup.string()
    .trim("SPACE_VALIDATION")
    .strict(true)
    .matches(namePattern, "SPECIAL_CHAR_VALIDATION")
    .min(1, "FIRST_NAME_REQ_VALIDATION")
    .required("FIRST_NAME_REQ_VALIDATION"),
  lastName: Yup.string()
    .trim("SPACE_VALIDATION")
    .strict(true)
    .matches(namePattern, "SPECIAL_CHAR_VALIDATION")
    .min(1, "LAST_NAME_REQ_VALIDATION")
    .required("LAST_NAME_REQ_VALIDATION"),
  dob: registrationDobSchema("NUTRITION_INSMANUAL_VAL_HOLDER_DOB"),
  memberId: Yup.string()
    .trim()
    .required("SELECT_MEMBERID_VALIDATION")
    .min(1, "SELECT_MEMBERID_VALIDATION"),
  groupNumber: Yup.string().trim().nullable(),
  relationship: Yup.string()
    .trim()
    .required("NUTRITION_INSMANUAL_VAL_RELATIONSHIP"),
  policyHolderFirstName: Yup.string().when("relationship", {
    is: requiresPolicyHolderFields,
    then: Yup.string()
      .trim("SPACE_VALIDATION")
      .strict(true)
      .matches(namePattern, "SPECIAL_CHAR_VALIDATION")
      .min(1, "NUTRITION_INSMANUAL_VAL_HOLDER_FIRST_NAME")
      .required("NUTRITION_INSMANUAL_VAL_HOLDER_FIRST_NAME"),
    otherwise: Yup.string().trim().nullable(),
  }),
  policyHolderLastName: Yup.string().when("relationship", {
    is: requiresPolicyHolderFields,
    then: Yup.string()
      .trim("SPACE_VALIDATION")
      .strict(true)
      .matches(namePattern, "SPECIAL_CHAR_VALIDATION")
      .min(1, "NUTRITION_INSMANUAL_VAL_HOLDER_LAST_NAME")
      .required("NUTRITION_INSMANUAL_VAL_HOLDER_LAST_NAME"),
    otherwise: Yup.string().trim().nullable(),
  }),
  policyHolderDob: Yup.string().when("relationship", {
    is: requiresPolicyHolderFields,
    then: registrationDobSchema("NUTRITION_INSMANUAL_VAL_HOLDER_DOB"),
    otherwise: Yup.string().trim().nullable(),
  }),
});

export const isInsuranceVerificationFormComplete = (values) => {
  try {
    insuranceVerificationValidationSchema.validateSync(values, {
      abortEarly: true,
    });
    return true;
  } catch {
    return false;
  }
};

const formikEnhancer = withFormik({
  validationSchema: insuranceVerificationValidationSchema,
  mapPropsToValues: () => ({ ...insuranceVerificationInitialValues }),
  handleSubmit: () => {},
  displayName: "InsuranceVerificationForm",
  enableReinitialize: true,
  validateOnBlur: true,
  validateOnChange: true,
  isInitialValid: false,
});

export default formikEnhancer;
